import { render, staticRenderFns } from "./EDIOrderSummary.vue?vue&type=template&id=684290eb&scoped=true&"
import script from "./EDIOrderSummary.vue?vue&type=script&lang=js&"
export * from "./EDIOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684290eb",
  null
  
)

export default component.exports